import { FC } from 'react'
import { DataTable } from 'components/table'
import { useQueryBuilder } from 'hooks/useQueryBuilder'
import useTableWithBackendData from 'hooks/useTableWithBackendData'
import {
  BlockedDomain,
  useGetApiV1DomainBlockQuery,
  GetApiV1AdminDomainBlockApiArg,
  GetApiV1AdminDomainBlockApiResponse,
} from '@wellesley/openapi'

import type { AboutServerSectionProps } from '../../types'

import { domainAndStateColumns, allColumns } from './helpers'

type BlockedDomainsProps = Pick<
  AboutServerSectionProps,
  'showBlockedDomainsReason'
>

const BlockedDomains: FC<BlockedDomainsProps> = ({
  showBlockedDomainsReason,
}) => {
  const columns = showBlockedDomainsReason ? allColumns : domainAndStateColumns

  const { buildQueryArgs } = useQueryBuilder({
    supportedFilters: [],
  })

  const { table, isLoading, isFetching } = useTableWithBackendData<
    BlockedDomain,
    GetApiV1AdminDomainBlockApiArg,
    GetApiV1AdminDomainBlockApiResponse
  >({
    columns,
    enableRowSelection: false,
    enableColumnPinning: false,
    enablePinning: false,
    columnResizeMode: 'onChange',
    enableColumnResizing: false,
    useQuery: useGetApiV1DomainBlockQuery,
    queryArgsBuilder: buildQueryArgs,
  })

  return <DataTable table={table} isLoading={isLoading || isFetching} />
}

export default BlockedDomains
